import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from './AllProviders';
import { BrandingController } from '@/components/Common/BrandingController';

interface Props {
  readonly children: ReactNode;
}

export default function WhiteLabelProvider({ children }: Props) {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        {children}
        <WiteLabelHeadUpdater />
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export const WiteLabelHeadUpdater = () => {
  return <BrandingController title='NextBrand' faviconUrl='' description='NextBrand' />;
};
